import Avatar from "../Avatar";
import { PublicUserOrganization } from "../../__generated__/graphql";
import { cn } from "../../lib/utils";

interface Participant {
  id: string;
  publicUserOrganization: PublicUserOrganization;
}

interface ParticipantsAvatarsProps {
  participants: Participant[];
  maxDisplayed?: number;
  className?: string;
  withBackground?: boolean;
}

export default function ParticipantsAvatars({
  participants,
  maxDisplayed = 6,
  className,
  withBackground = false,
}: ParticipantsAvatarsProps) {
  if (participants.length === 0) {
    return null;
  }

  const displayedParticipants = participants.slice(0, maxDisplayed);
  const remainingCount = participants.length - maxDisplayed;

  return (
    <div
      className={cn(
        "flex -space-x-2 items-center flex-shrink-0",
        withBackground && "bg-card border border-border rounded-md p-0.5",
        className
      )}
    >
      {displayedParticipants.map((participant) => (
        <Avatar
          key={participant.id}
          size="small"
          userOrganization={participant.publicUserOrganization}
        />
      ))}
      {remainingCount > 0 && (
        <div className="flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold bg-accent text-dark border-2 border-card">
          +{remainingCount}
        </div>
      )}
    </div>
  );
}
